export default __webpack_public_path__ + "static/media/more_dot_card.7e0574be.svg";